import { render } from "./UserAuth.vue?vue&type=template&id=38040a5e&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=38040a5e&lang=css"
import "./UserAuth.vue?vue&type=style&index=1&id=38040a5e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38040a5e"]])

export default __exports__